module.exports = __webpack_public_path__ + "img/creamy-mustard-tarragon-chicken.67acf828.jpg";